import React from "react";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsSliders } from "react-icons/bs";
import { longDateString } from "../../utils";
import "bootstrap/dist/css/bootstrap.min.css";

const DeviceProfilesListingView = ({
    profiles = [],
    selectedRows = [],
    onSelectedRowsChange = () => {},
    onEdit = () => {},
    onDelete = () => {},
    onConfigure = () => {},
}) => {
    const columns = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
            width: "250px",
        },
        {
            name: "Description",
            selector: (row) => row.description || "-",
            sortable: true,
            wrap: true,
        },
        {
            name: "Actions",
            cell: (row) => (
                <Button
                    variant="primary"
                    size="sm"
                    onClick={() => onConfigure(row)}
                    style={{ whiteSpace: "nowrap" }}
                >
                    <BsSliders className="mr-2" />
                    Configure
                </Button>
            ),
            width: "160px",
            center: true,
        },
        {
            name: "Activity",
            selector: (row) => row.updated_at,
            sortable: true,
            width: "250px",
            cell: (row) => (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip>
                            <div>
                                Created by {row.created_by?.name || "Unknown"}{" "}
                                at {longDateString(row.created_at)}
                            </div>
                            <div>
                                Modified by {row.updated_by?.name || "Unknown"}{" "}
                                at {longDateString(row.updated_at)}
                            </div>
                        </Tooltip>
                    }
                >
                    <div style={{ fontSize: "0.85rem" }}>
                        {row.updated_by?.name || "Unknown"} at{" "}
                        {longDateString(row.updated_at)}
                    </div>
                </OverlayTrigger>
            ),
        },
    ];

    return (
        <div>
            <DataTable
                columns={columns}
                data={profiles}
                keyField="id"
                selectableRows
                onSelectedRowsChange={onSelectedRowsChange}
                selectedRows={selectedRows}
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[5, 10, 20]}
                striped
                highlightOnHover
                responsive
            />
        </div>
    );
};

export default DeviceProfilesListingView;
